import { Input } from './input';
import * as styles from './instagramHandleInput.css';

type InstagramHandleInputProps = {
  value: string;
  onValueChange: (value: string) => void;
  label: string;
  ariaLabel: string;
  testId?: string;
  autoFocus?: boolean;
  supportingText?: string;
  disabled?: boolean;
  wrapperClassName?: string;
  inputWrapperClassName?: string;
};

const normalizeHandleValue = (value: string): string => {
  return value.replace(/^@+/, '');
};

export const InstagramHandleInput = ({
  value,
  onValueChange,
  label,
  ariaLabel,
  testId,
  autoFocus,
  supportingText,
  disabled,
  wrapperClassName,
  inputWrapperClassName,
}: InstagramHandleInputProps) => {
  return (
    <Input
      aria-label={ariaLabel}
      type="text"
      label={label}
      testId={testId}
      autoFocus={autoFocus}
      value={value}
      disabled={disabled}
      startCta={
        <span aria-hidden className={styles.atGlyph}>
          @
        </span>
      }
      supportingText={supportingText}
      wrapperClassName={wrapperClassName}
      inputWrapperClassName={inputWrapperClassName}
      onChange={(event) =>
        onValueChange(normalizeHandleValue(event.currentTarget.value))
      }
    />
  );
};
